import React from 'react';
import './PriceHistory.css';
import { formatPLN } from '@repo/domain';

function PriceHistory({ priceHistory, salesStartDate }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Use only price history from property_price_versions
  const allPriceData = (priceHistory || []).sort((a, b) => new Date(b.date) - new Date(a.date));

  // Mark the first (newest) price as current
  if (allPriceData.length > 0) {
    allPriceData[0].isCurrent = true;
  }

  return (
    <div className="price-history">
      <h3>Historia cen</h3>
      <div className="sales-start-info">
        <span className="label">Początek sprzedaży:</span>
        <span className="date">{formatDate(salesStartDate)}</span>
      </div>
      
      <div className="price-timeline">
        {allPriceData.map((pricePoint, index) => (
          <div key={index} className="price-point">
            <div className="date">{formatDate(pricePoint.date)}</div>
            <div className="prices">
              <div className="total-price">
                {formatPLN(pricePoint.totalPrice.value)}
              </div>
              <div className="price-per-sqm">
                {Number.isFinite(pricePoint.pricePerSquareMeter.value)
                  ? `${formatPLN(pricePoint.pricePerSquareMeter.value)}/m²`
                  : formatPLN(pricePoint.pricePerSquareMeter.value)}
              </div>
            </div>
            {pricePoint.isCurrent && (
              <span className="current-badge">Aktualna</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PriceHistory;